@if (control) {
  @if (controlParent==='ContactInfo') {
    <div>
      @if (control.invalid && (control.dirty || control.touched)) {
        <div class="input-validation-container extra-content">
          @for (error of control.errors | keyvalue; track error) {
            <div [id]="'validation-' + controlName" class="validation-text extra-text">
              <span class="fa fa-exclamation-circle"></span>
              {{error.value}}
            </div>
          }
        </div>
      }
    </div>
  } @else {
    @if (control.invalid && (control.dirty || control.touched)) {
      <div class="input-validation-container">
        @for (error of control.errors | keyvalue; track error) {
          <div [id]="'validation-' + controlName" class="validation-text">
            {{error.value}}
          </div>
        }
      </div>
    }
  }
}

